import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useDispatch } from 'store/hooks';
import {
    InscriptionT,
    inscriptionUpdateApiCall,
} from 'routes/BudgetModule/shared/entities/inscription';
import { INSCRIPTION_ID } from 'routes/BudgetModule/config/constants';
import { trackEventBudget } from 'helpers/trackerHelpers';
import { InscriptionQueryKey } from 'routes/BudgetModule/helpers/createBudgetQueryKeys';
import { BudgetProposalResourceMetadataT } from 'routes/BudgetModule/config/types';

export const useUpdateOrphanInscription = (
    queryCacheKey: InscriptionQueryKey,
    trackingInformation?: {
        eventName: string;
        metadata?: BudgetProposalResourceMetadataT;
    },
) => {
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: inscriptionUpdateApiCall,
        onSuccess: (response, { id }) => {
            dispatch.vision.notifyUser({
                message: response.content.message,
                snackType: 'success',
            });

            const inscriptionUpdatedFields = response.content.data;
            if (trackingInformation)
                trackEventBudget(
                    trackingInformation.eventName,
                    trackingInformation.metadata,
                );
            queryClient.setQueryData(
                queryCacheKey,

                (oldInscriptions: { data: InscriptionT[] }) => ({
                    ...oldInscriptions,
                    data: oldInscriptions.data.map((item) =>
                        item[INSCRIPTION_ID as keyof InscriptionT] === id
                            ? { ...item, ...inscriptionUpdatedFields }
                            : item,
                    ),
                }),
            );
        },
        onError: (error: Error) => {
            dispatch.vision.notifyUser({
                message: error.message,
                snackType: 'error',
            });
        },
    });
};
